/** React Query keys for the Customer Statement feature. */
export const customerStatementKeys = {
  all: ['customer-statement'] as const,
  mailJob: (id: string) => [...customerStatementKeys.all, 'mail-job', id] as const,
  activeMailJob: (companyId: number) => [...customerStatementKeys.all, 'mail-job-active', companyId] as const,
  lastSent: (companyId: number) => [...customerStatementKeys.all, 'last-sent', companyId] as const,
  replies: (companyId: number) => [...customerStatementKeys.all, 'replies', companyId] as const,
  inbox: (companyId: number) => [...customerStatementKeys.all, 'reply-inbox', companyId] as const,
  conversation: (companyId: number, customerId: number) =>
    [...customerStatementKeys.all, 'conversation', companyId, customerId] as const,
};
